<script lang="ts">
	import {
		DEFAULT_ANIMATION_DURATION_CLASS,
		DEFAULT_VARIANTS,
		getAnimationDuration,
		isSvelteStore
	} from '../Utils.js';
	import { cva, type VariantProps } from 'class-variance-authority';
	import { innerHeight, innerWidth } from 'svelte/reactivity/window';
	import type { Writable } from 'svelte/store';
	import { fade } from 'svelte/transition';
	import { twMerge } from 'tailwind-merge';

	const tooltipClasses = cva(
		[
			'text-sm!',
			'fixed',
			'px-3',
			'py-1',
			'rounded-base',
			'shadow-lg',
			'top-0',
			'left-0',
			'max-w-[300px]',
			'z-10'
		],
		{
			defaultVariants: { variant: 'default' },
			variants: { variant: DEFAULT_VARIANTS }
		}
	);
	type Props = VariantProps<typeof tooltipClasses>;

	type TooltipProps = {
		title: string | Writable<string>;
		visible?: boolean | undefined;
		x: number;
		y: number;
		variant?: Props['variant'];
	};

	let { title, visible, x = 0, y = 0, variant }: TooltipProps = $props();

	let className: string | undefined = undefined;
	export { className as class };

	let dynamicTitle = isSvelteStore(title) ? title : null;

	let element: HTMLDivElement | undefined = $state();
	let classes = $derived(twMerge(tooltipClasses({ className, variant })));
</script>

{#if visible}
	<div
		bind:this={element}
		class={classes}
		in:fade|local={{ duration: getAnimationDuration(DEFAULT_ANIMATION_DURATION_CLASS) }}
		out:fade|local={{ duration: getAnimationDuration(DEFAULT_ANIMATION_DURATION_CLASS) }}
		style={element && innerHeight && innerWidth && innerHeight.current && innerWidth.current
			? `transform: translate(${
					x + element.offsetWidth + 5 < innerWidth.current ? x + 5 : x - element.offsetWidth - 5
				}px, ${y + element.offsetHeight + 5 < innerHeight.current ? y + 10 : y - element.offsetHeight - 10}px);`
			: ''}
	>
		{#if dynamicTitle}
			{$dynamicTitle}
		{:else}
			{title}
		{/if}
	</div>
{/if}
